// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


// The #{TokenName}# will be replaced during the AzDO release process using AzDO variables

import { EnvironmentOptions } from './environment-options';


export const environment: EnvironmentOptions = {
  production: !!'#{production}#',
  assetOptimizationURL: '#{AssetOptimizationURL}#',
  authCookieName: '#{AuthCookieName}#',
  authTokenName: '#{AuthTokenName}#',
  useCookie: true,
  baseUrl: '#{baseUrl}#',
  paymentGatewayUrl: '#{PaymentGatewayURL}#'
};



// WEBPACK FOOTER //
// /azp/_work/1/s/src/environments/environment.ts